export default __webpack_public_path__ + "static/media/menu-chevron.44340a4b.svg";